import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { driver } from './shared/models/driver.model';
import { DriverService } from './shared/services/driver.service';

@Component({
  selector: 'app-drivers',
  templateUrl: './drivers.component.html',
  styleUrls: ['./drivers.component.css']
})
export class DriversComponent implements OnInit {
  pageNo: number = 1;
  pageSize: number = 10;
  drivers: any;
  isShowPassword: boolean;
  driverVM: driver;
  @ViewChild("driver") driver: NgForm;
  constructor(public _driverSvc: DriverService, private _modalSvc: NgbModal, private _toastrSvc : ToastrService) { }

  ngOnInit() {
    this.resetForm();
    this.getDriver(this.pageNo);
  }

  resetForm() {
    this.isShowPassword = true;
    this.driverVM = {
      FirstName: "",
      LastName: "",
      Phone: "",
      AlternatePhone: "",
      Email: "",
      Password: "",
      RetypePassword: "",
      AddressLine1: "",
      AddressLine2: "",
      Zipcode: "",
      City: "",
      State: "",
      ID: 0,
      InsertDate: '',
      LastUpdatedBy: '',
      LastUpdatedById: null,
      CreatedBy: "",
      CreatedById: null,
      IsActive: true,
      IsDefaultDriver: false,
      CreatedUserId: null,
      OldEmployeeId: null,
      Forgotkey: '',
      FullName: '',
      HasErrors: false,
      UserName: '',
      ModifiedDate: '',
      ResultMessages: [],
      Salt: ''
    }
  }

  getDriver(pageNo : number){
    this._driverSvc.getDrivers(this.pageNo, this.pageSize).subscribe(response => {
      this.drivers = response;
    });
  }

  cancelForm(){
    this.resetForm();
  }

  saveDriver() {
    debugger;
    this._driverSvc.saveDriver(this.driverVM).subscribe(response => {
      if (response) {
        this._toastrSvc.success("Driver saved successfully", null, {
          positionClass:'toast-bottom-right'
        });
        this.driver.resetForm();
        this.drivers = response;
      }

    });
  }

  confirmPassword() {
    if (this.driverVM.Password === this.driverVM.RetypePassword) {
      return true;
    }
    else
      return false;
  }
  updateDriver(mod: driver) {
    this.isShowPassword = false;
    this.driverVM = Object.assign({}, mod);
  }

  changePasswordPopup(DriverId) {
    debugger;
    const modalRef = this._modalSvc.open(ChangePasswordComponent);
    modalRef.componentInstance.DriverId = DriverId;
  }
  dismiss() {
    this._modalSvc.dismissAll();
  }

}
